module.exports = __webpack_public_path__ + "img/erding.f810e6a1.png";